module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Bulb#1-345426e8610786e6870462cd7086cf084d938ca30d6fdf7e612327edfb9287de.svg";